module.exports = __webpack_public_path__ + "static/media/banner_1920x350-2.a08dbd4d.jpg";